<template>
  <div class="px-4">
    <h1>Your order</h1>

    <template v-if="sortedBasket.length">
      <div class="border-t border-gray-300 border-solid mb-4">
        <basket-item  
          v-for="(item,i) in sortedBasket" 
          :key="i"
          :item="item"
          @remove="removeFromBasket(item)"
          @edit="edit(item)"
        />
      </div>
      <div class="flex justify-end items-center font-bold mb-4">
        <p>Total</p>
        <p style="width: 60px" class="text-right ml-2 sm:ml-4">{{total | currency}}</p>
      </div>
    </template>   


    <template v-if="!soldout">
      <template v-if="sortedBasket.length == 0">
        <p class="w-100 mt-8 mb-2 text-lg text-center mx-2" >
          Father's Day cupcakes
        </p>
        <p class="w-100 mb-2 text-sm text-center mx-2" v-if="sortedBasket.length == 0">
          Available for collection Friday 17th and Saturday 18th June
        </p>
      </template>
      <template>
        <div class="flavours px-2 sm:px-0 sm:flex sm:-mx-2 align-stretch font-xs mb-8">
          <template v-if="sortedBasket.length == 0 || hasSpecial">
            <standard-button @click="goTo('add-special-cupcakes')">Add Father's Day cupcakes</standard-button>
            <standard-button @click="goTo('add-special-cake')" v-if="false">Add a Christmas cake</standard-button>
          </template>
        </div>
      </template>

      <template v-if="sortedBasket.length == 0">
        <p class="w-100 mt-8 mb-2 text-lg text-center mx-2" >
          Standard cupcakes
        </p>
        <p class="w-100 mb-2 text-sm text-center mx-2" v-if="sortedBasket.length == 0 && false">
          Available for collection until 11th December, then again from January
        </p>
      </template>
    </template>

    <div class="flavours px-2 sm:px-0 sm:flex sm:-mx-2 align-stretch font-xs mb-8">
      <template v-if="sortedBasket.length == 0 || !hasSpecial">
        <standard-button @click="goTo('add-cupcakes')">Add cupcakes</standard-button>
        <standard-button @click="goTo('add-cake')">Add a cake</standard-button>
      </template>
    </div>


    <p class="w-100 mt-8 mb-2 text-sm text-center mx-2" v-if="sortedBasket.length == 0 && soldout && false">
      Sorry - our Father's Day Cupcakes have sold out.
    </p>

    <template v-if="sortedBasket.length">
      <OrderDetails :basket="basket" :total="total" :special="hasSpecial" />
    </template>


    

  </div>
</template>

<script>

const specialData = require('../../functions/data/specials.json');
import { filter, sortBy, map, sum, keyBy, some } from 'lodash'
import BasketItem from '../components/BasketItem'
import StandardButton from '../components/FlavourButton'
import OrderDetails from '../components/OrderDetails'
import lscache from 'lscache';
import dayjs from 'dayjs'
export default {

  data: () => ({
    basket: [],
    specialData
  }),

  components: {
    BasketItem,
    StandardButton,
    OrderDetails
  },

  computed: {
    fathersday() {
      return this.specialData.dates.length < 3
    },
    soldout() {
      return dayjs().isAfter(dayjs('2022-06-19'))
    },
    sortedBasket() {
      return sortBy(this.basket, 'id')
    },
    total() {
      const productsBySku = keyBy(this.$root.$data.products, 'sku')
      return sum(map(this.basket, o => productsBySku[o.sku].amount))
    },
    hasSpecial() {
      const productsBySku = keyBy(
        filter(this.$root.$data.products,{special: true}), 'sku')
      return some(map(this.basket, o => productsBySku[o.sku]))

    }


  },

  mounted() {
    if(lscache.get('basket')) {
      this.basket = lscache.get('basket')
    }
    // if(this.sortedBasket.length == 0) {
    //   this.$router.push("/order/cakes")
    // }
  },

  methods: {
    edit(item) {
      console.log(item)
      this.$router.push({
        name: item.cake ? "edit-cake" : "edit-cupcakes",
        params: {
          id: item.id
        }
      })
    },
    goTo(name) {
      this.$router.push({
        name: name
      })
    },
    removeFromBasket(item) {
      this.basket = filter(this.basket, o => o.id != item.id)
    },
  },

  watch: {
    basket: {
      handler(newBasket) {
        lscache.set('basket', newBasket, 60 * 24 * 3)
      },
      deep: true
    }
  },
  head: {
    title() {
      return {
        inner: "Order"
      }
    }
  }

}
</script>

<style>

</style>
